import { FunctionComponent } from 'react'
import classnames from 'classnames'

import authCss from './auth.module.scss'

const AuthFooter: FunctionComponent<{ className?: string }> = ({ className }) => (
  <footer className={classnames(authCss.footer, className)}>
    <span>© {new Date().getFullYear()} Clic-repasse</span>
    <nav className={authCss.footerLinks} aria-label="Links do rodapé">
      <a href="https://clicrepasse.com.br/termos-de-uso" target="_blank" rel="noopener noreferrer">
        Termos de Uso
      </a>
      <a
        href="https://clicrepasse.com.br/politica-de-privacidade"
        target="_blank"
        rel="noopener noreferrer"
      >
        Política de Privacidade
      </a>
    </nav>
  </footer>
)

export default AuthFooter
